import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import SlSkeleton from 'src/components/BeaconV2Components/SlSkeleton/SlSkeleton';

export const MicroTrendsCardLoading = () => {
  return (
    <Flex flexDirection="column" gap={8} width="356px">
      {/* Badge skeletons - multiple week badges */}
      <Flex alignItems="center" gap={8}>
        <SlSkeleton variant="rounded" height={24} width={80} />
        <SlSkeleton variant="rounded" height={24} width={80} />
      </Flex>

      {/* Heading skeleton - "JBL - Headphones" */}
      <Flex flexDirection="column">
        <SlSkeleton variant="rounded" height={36} width="85%" />
      </Flex>

      {/* Description paragraph skeleton */}
      <Flex flexDirection="column" gap={4} marginTop="3px">
        <SlSkeleton variant="rounded" height={120} width="100%" />
      </Flex>

      {/* Products count skeleton - "X PRODUCTS" */}
      <Flex marginTop="8px">
        <SlSkeleton variant="rounded" height={20} width={120} />
      </Flex>

      {/* Learn more link skeleton */}
      <Flex style={{ marginTop: '24px' }}>
        <SlSkeleton variant="rounded" height={24} width={220} />
      </Flex>
    </Flex>
  );
};

export const MicroTrendsChartLoading = () => {
  return (
    <Flex flexDirection="column" width="592px" height="300px">
      <SlSkeleton variant="rounded" width={70} height={20} style={{ marginTop: '4px' }} />
      <Flex alignItems="center">
        <SlSkeleton variant="rounded" width={120} height={40} style={{ marginTop: '4px' }} />
        <SlSkeleton variant="rounded" width={80} height={18} style={{ marginLeft: '16px' }} />
      </Flex>

      <Flex width="700px" height="212px" marginTop="26px">
        <SlSkeleton variant="rounded" width="80%" height="100%" />
      </Flex>
    </Flex>
  );
};
